<template>
    <!-- Sidebar -->
    <div class="navbar-toggler left-menu d-none d-lg-block navbar-expand-lg sidebar sidebar-dark accordion vecindapp-sidebar" id="accordionSidebar">
        <!-- Sidebar - Brand -->
        <a class="sidebar-brand1 d-flex align-items-center justify-content-center my-3" href="index.html" @click.prevent="">
            <div class="sidebar-brand-icon">
                <b-img v-if="!isReseller" src="img/logo_vecindapp.png" @click.prevent="navigateTo()" style="max-width: 150px"></b-img>
                <b-img v-else :src="currentClient?.logo_url ?? 'img/logo_vecindapp.png'" @click.prevent="navigateTo()" style="max-width: 150px"></b-img>
            </div>
        </a>

        <!-- Divider -->
        <hr class="sidebar-divider my-0" />

        <!-- Nav Item - Dashboard -->
        <li class="nav-item active">
            <a class="nav-link" href="#" @click.prevent="">
                <i class="fas fa-fw fa-tachometer-alt"></i>
                <span>Menu</span>
            </a>
        </li>

        <!-- Divider -->
        <hr class="sidebar-divider" />
        <!-- Nav Item - Pages Collapse Menu -->
        <app-menu v-for="(item, i) in menu" :key="item.id" :label="item.name" :items="item.menuItems" :index="i" />

        <!-- Divider -->
        <hr class="sidebar-divider d-none d-md-block" />

        <div v-if="isReseller">
            <b-img src="/img/logo_vecindapp.png"></b-img>
        </div>
    </div>
    <!-- End of Sidebar -->
</template>

<script>
import { mapGetters } from 'vuex'
import appMenu from './Menu'
export default {
    components: {
        appMenu,
    },
    computed: {
        ...mapGetters(['menu']),
    },
    data: () => ({}),
    methods: {
        navigateTo() {
            const defaultScreen = this.currentProfile.default_screen
            if (this.$route.name === defaultScreen) return
            this.$router.push({ name: defaultScreen })
        },
    },
}
</script>

<style scoped>
.vecindapp-sidebar {
    margin-top: -3px;
}

.left-menu {
    background: rgb(73, 2, 80);
    background: linear-gradient(180deg, rgba(73, 2, 80, 1) 0%, rgba(2, 121, 138, 1) 100%);
}
.nav-item {
    list-style-type: none;
}
</style>
